"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Step_1 = __importDefault(require("./Step"));
const EconomicField_1 = __importDefault(require("./EconomicField"));
const EconomicStepService_1 = __importDefault(require("../services/EconomicStepService"));
const BecropPlan_1 = __importDefault(require("./BecropPlan"));
const economicStepService = new EconomicStepService_1.default();
class EconomicStep extends Step_1.default {
    constructor(config) {
        super(config.id);
        this.data = config.data;
    }
    get totalPrice() {
        var _a;
        let price = 0;
        this.data.selectedFields.forEach((field) => {
            price += field.totalPrice;
        });
        return `${price.toFixed(2)}${(_a = this.data.fields[0]) === null || _a === void 0 ? void 0 : _a.becropPlan.unitPrice}`;
    }
    addSelectedFields(field) {
        this.data.selectedFields.push(field);
    }
    createEconomicField(field) {
        const fieldConfigData = this.createFieldConfigData(field);
        const economicFieldConfigData = this.createEconomicFieldConfigData('Farm', 7, field.size);
        return new EconomicField_1.default({
            fieldConfig: fieldConfigData,
            economicFieldConfig: economicFieldConfigData
        });
    }
    createFieldConfigData(field) {
        return {
            id: field.id,
            gfId: field.gfId,
            fieldName: field.fieldName,
            farmId: field.farmId,
            farmName: field.farmName,
            size: field.size,
            sizeUnit: field.sizeUnit,
            managementPractice: field.managementPractice,
            crop: field.crop,
            geodata: field.geodata,
            origin: field.origin,
            metadata: field.metadata,
            projection: field.projection,
            quoteId: field.quoteId,
            ebecrop: field.ebecrop,
            provider: field.provider,
            providerFieldId: field.providerFieldId,
        };
    }
    createEconomicFieldConfigData(type, pricePerExtension, fieldSize) {
        const totalPrice = pricePerExtension * fieldSize;
        return {
            becropPlan: new BecropPlan_1.default({ type: type, pricePerExtension: pricePerExtension, unitPrice: '$' }),
            totalPrice: totalPrice
        };
    }
    /* async getFields(){
        await economicStepService.getFields();
        const economicFields = economicStepService.fields.map(field => this.createEconomicField(field));
        this.addFields(economicFields)
    } */
    addFields(fields) {
        fields.forEach(field => { this.data.fields.push(field); });
    }
    resetFields() {
        this.data.fields = [];
    }
    removeSelectedField(fieldId) {
        this.data.selectedFields = this.data.selectedFields.filter(field => { return field.id !== fieldId; });
    }
    resetStep() {
        this.data.fields = [];
    }
    resetSelectedFields() {
        this.data.selectedFields = [];
    }
}
exports.default = EconomicStep;
